/**
 * Module type constants used throughout the application
 */
export const MODULE_TYPES = {
    TROLLEY_SHELTER: 'trolleyshelter',
    ZONE_TRACKER: 'zonetracker',
    LINE_TRACKER: 'linetracker'
} as const;

/**
 * Types props
 */
export const TYPE_PROPS = {
    RFID_TAG_SHOPPING_TIME: 'rfidTagShoppingTime'
} as const;

/**
 * Helper function to normalize module type to lowercase
 */
export const normalizeModuleType = (moduleType: string): string => {
    return moduleType.toLowerCase();
};
